export const kindgrouplist = ['Equipo_de_Lideres', 'Grupo_Discipulado', 'Grupo_Seminario'];

/** Canonical kind values (same in DB and UI). */
export const GROUP_KINDS = {
  DISCIPULADO: 'Grupo_Discipulado',
  SEMINARIO: 'Grupo_Seminario',
  LIDERES: 'Equipo_de_Lideres',
};

export const isSeminarioKind = (kind = '') => kind === GROUP_KINDS.SEMINARIO;
export const isDiscipuladoKind = (kind = '') => kind === GROUP_KINDS.DISCIPULADO;

export const counselingProfessionalFields = ['Psicologia', 'Consejero'];

export const seminary = ['Para_Siempre._', 'Transformacion_Empresarial._'];

export const comunidadProcess = ['Crecer_Encuentro', 'Crecer_Vida', 'Crecer_Influencia'];
